import React from 'react';

import { Card, CardBody } from '@react/react-spectrum/Card';
import DeviceDesktop from '@react/react-spectrum/Icon/DeviceDesktop';
import DevicePhone from '@react/react-spectrum/Icon/DevicePhone';
import Servers from '@react/react-spectrum/Icon/Servers';

import './LaunchPropertyList.scss';

export default function LaunchPropertyList({ data }) {
  const openLaunch = (property) => () => {
    window.open(property.launchUrl);
  };

  if (data.length === 0) {
    return <p>No properties found</p>;
  }

  return (
    <div className="launch-property-list">
      {Array.isArray(data) &&
        data.map((property) => (
          <Card
            allowsSelection={false}
            onClick={openLaunch(property)}
            key={`property-${property.propertyID}`}>
            <CardBody title={property.propertyName} subtitle={property.config}>
              <PropertyTypeIcon type={property.type} />
            </CardBody>
          </Card>
        ))}
    </div>
  );
}

const PropertyTypeIcon = ({ type }) => {
  let icon;
  switch (type) {
    case 'mobile':
      icon = <DevicePhone size="S" />;
      break;
    case 'web':
      icon = <DeviceDesktop size="S" />;
      break;
    case 'server':
      icon = <Servers size="S" />;
      break;
  }

  return <div className="launch-property-type-icon">{icon}</div>;
};
